import ApiService from 'global/utils/ApiService';
import endpointUrls from 'global/Constants/endpointUrls';
import { IBackendSearchGeneric } from 'global/Models/globalModels';
import { AppDispatch } from 'redux/store';
import { deliveryType } from 'global/Models/omOrderModel';
import { setOrderDeliveryTypes } from 'redux/reducer/ParcelOrder/parcelOrderReducer';

export const getDeliveryTypes = () => async (dispatch: AppDispatch) => {
  await ApiService.post(endpointUrls.deliveryTypeGetAll, { recordsPerPage: 50 })
    .then((res: IBackendSearchGeneric<deliveryType>) => {
      res.isSuccess && dispatch(setOrderDeliveryTypes(res.data));
    })
    .catch(() => {});
};
